var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { request, getAnalyticsRequestBody } from "../utils/request";
import { determineInterval } from "../utils/intervals";
import { useTectonicContext } from "../components/TectonicProvider";
import { ErrorBoundary } from "../components/ErrorBoundary";
export const AggregateTimeSeries = (_a) => {
    var { baseUrl, token, timeRange, children, interval: propsInterval, onIntervalChange = () => { }, timeZone } = _a, params = __rest(_a, ["baseUrl", "token", "timeRange", "children", "interval", "onIntervalChange", "timeZone"]);
    let ctx = useTectonicContext();
    if (!baseUrl)
        baseUrl = ctx.baseUrl;
    if (!token)
        token = ctx.token;
    if (timeRange === undefined)
        timeRange = ctx.timeRange;
    const isReady = ctx.token ? ctx.token && ctx.isReady : token;
    const [interval, setInterval] = React.useState(propsInterval);
    React.useEffect(() => {
        setInterval(propsInterval);
    }, [propsInterval]);
    React.useEffect(() => {
        if (interval) {
            onIntervalChange(interval);
        }
    }, [interval]);
    React.useEffect(() => {
        if (timeRange) {
            setInterval(determineInterval(timeRange));
        }
    }, [timeRange]);
    const [data, setData] = React.useState([]);
    const [status, setStatus] = React.useState({ loading: true });
    async function fetchData() {
        setStatus({ loading: true });
        let _interval = interval;
        if (!_interval && timeRange) {
            _interval = determineInterval(timeRange);
        }
        try {
            const { data } = await request({
                method: "POST",
                path: "/1/analytics/time-series",
                baseUrl,
                token,
                body: getAnalyticsRequestBody({
                    params: Object.assign(Object.assign({}, params), { dateField: params.dateField || ctx.dateField, interval: _interval, timeZone: (ctx === null || ctx === void 0 ? void 0 : ctx.timeZone) || timeZone }),
                    timeRange,
                    ctx,
                }),
                onRequest: ctx.onRequest,
            });
            setData(data);
            setStatus({ success: true });
        }
        catch (error) {
            setStatus({ error: error });
        }
    }
    React.useEffect(() => {
        const timeoutId = setTimeout(() => {
            if (isReady) {
                fetchData();
            }
            else if (!token) {
                setStatus({ error: new Error("Token not provided") });
            }
        }, 300);
        return () => clearTimeout(timeoutId);
    }, [token, baseUrl, isReady, interval, timeRange, ...Object.values(params)]);
    if (typeof children === "function") {
        try {
            return children({ data, status });
        }
        catch (error) {
            return React.createElement(ErrorBoundary, { centered: true, error: error });
        }
    }
    return React.Children.map(children, (child) => React.cloneElement(child, {
        data,
        status,
        timeRange,
        interval,
        onIntervalChange: setInterval,
    }));
};
//# sourceMappingURL=AggregateTimeSeries.js.map